import { useTranslations } from 'use-intl';
import { Link } from '@tanstack/react-router';
import { Button, EmptyState, I, Stack } from '@leanin/ui';

export function NotFoundPage() {
  const t = useTranslations('Shell');
  return (
    <Stack align="center" justify="center" py="page" style={{ minHeight: '60vh' }}>
      <EmptyState
        density="page"
        icon={I.search}
        eyebrow="404"
        title={t('notFound.title')}
        body={t('notFound.body')}
        primary={
          <Button variant="primary" href="/feed" linkAs={Link}>
            {t('notFound.goHome')}
          </Button>
        }
        secondary={
          <Button variant="secondary" href="/directory" linkAs={Link}>
            {t('notFound.browseDirectory')}
          </Button>
        }
      />
    </Stack>
  );
}
